import { color, font, radius } from '../tokens'
import './header-control.css'

/** One border-box and typography contract for header tools and selection chips. */
export const headerControlStyle = {
  height: 'var(--kw-header-tool-height, var(--kw-component-header-control-height-desktop))',
  minHeight: 'var(--kw-header-tool-height, var(--kw-component-header-control-height-desktop))',
  boxSizing: 'border-box',
  border: `1px solid ${color.darkBorder}`,
  borderRadius: radius.pill,
  background: color.darkCard,
  color: color.white,
  fontFamily: font.sans,
  fontSize: 12,
} as const
